import { useSuspenseQuery } from '@tanstack/react-query';
import React from 'react';

import {
    Dialog,
    DialogBody,
    DialogCloseButton,
    DialogFooter,
    DialogHeader,
    Heading,
    LabeledContainer,
    LabeledContainerActionableTitle,
    LabeledContainerBody,
    LabeledContainerHeader,
    LoadingPanel,
} from '@gitbook/spine-react';

import { apiQuery } from '../../state';
import type { ConversationIssueDialogProps } from './ConversationIssueDialog';
import { ConversationIssuesTable } from './ConversationIssuesTable';

type ConversationDialogProps = {
    organizationId: string;
    conversationId: string;
} & Pick<ConversationIssueDialogProps, 'withClusterRelation'>;

/**
 * Dialog to inspect a conversation.
 */
export function ConversationDialog(props: ConversationDialogProps) {
    return (
        <Dialog>
            <React.Suspense fallback={<LoadingPanel />}>
                <ConversationDialogContent {...props} />
            </React.Suspense>
        </Dialog>
    );
}

function ConversationDialogContent(props: ConversationDialogProps) {
    const { organizationId, conversationId, withClusterRelation = true } = props;

    const {
        data: { conversation },
    } = useSuspenseQuery(apiQuery('getConversationById', { organizationId, conversationId }));

    return (
        <>
            <DialogHeader>
                <Heading>{conversation.subject ?? 'No subject'}</Heading>
            </DialogHeader>
            <DialogBody>
                <div className="flex flex-col gap-6">
                    <LabeledContainer>
                        <LabeledContainerHeader>
                            <LabeledContainerActionableTitle>
                                <Heading>Issues</Heading>
                            </LabeledContainerActionableTitle>
                        </LabeledContainerHeader>
                        <LabeledContainerBody>
                            <ConversationIssuesTable
                                organizationId={organizationId}
                                conversationId={conversationId}
                                withClusterRelation={withClusterRelation}
                                withConversationRelation={false}
                            />
                        </LabeledContainerBody>
                    </LabeledContainer>
                </div>
            </DialogBody>
            <DialogFooter>
                <DialogCloseButton label="Close" />
            </DialogFooter>
        </>
    );
}
